import type { PackageLabelAssignmentWithName } from '../../../../shared/model-typings/packagelabelassignment';

import type { VersionedLabelOption } from './types';

export const reduceAssignmentsToVersionMap = (
  acc: VersionedLabelOption,
  assignment: PackageLabelAssignmentWithName,
) => {
  const version = assignment.packageVersion ?? 'all';
  return {
    ...acc,
    [version]: (acc[version] || new Set()).add(assignment.labelId),
  };
};
